import type { ReactNode } from 'react'
import type { RouteObject } from 'react-router'
import LazyDesktopHandoff from './LazyDesktopHandoff'

/**
 * デスクトップアプリのサインイン受け渡し画面（#1620）。Root.tsx の AuthRedirect 配下に展開するので、
 * 未サインインならログイン画面へ送られ、サインイン後にこの URL（クエリ込み）へ戻る。
 * フラグが false なら空配列になり、ページのチャンクも出力されない。
 * フラグは呼び出し時に読む（テストで vi.stubGlobal を効かせるため）。
 */
export const desktopHandoffRoutes = (errorElement: ReactNode): RouteObject[] => FEATURE_DESKTOP_HANDOFF ? [
  {
    path: '/auth/desktop',
    Component: LazyDesktopHandoff,
    errorElement,
  },
] : []
